import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { useWeb3React } from "@web3-react/core";
import { getContracts } from "../../utils/getContracts";

const AllowClaimingHook = () => {
  const web3 = useWeb3();
  const { account } = useWeb3React();

  const allowClaimingHook = useCallback(
    async (bool, round, decision, project) => {
      const roundNum = round?.round;
      const version = round?.version;

      console.log("round in hook: ", round, project, roundNum);

      try {
        // Get all contracts for the project
        const { claimContract, claimContractV2, claimContractV3 } = getContracts(project, web3);

        // Select the appropriate contract based on version
        let selectedContract = claimContract;

        if (version === 2 && claimContractV2) {
          selectedContract = claimContractV2;
        } else if (version === 3 && claimContractV3) {
          selectedContract = claimContractV3;
        }

        if (!selectedContract) {
          throw new Error(`No claim contract found for project: ${project}, version: ${version}`);
        }

        // Check if claiming is enabled
        if (bool) {
          const details = await selectedContract.methods.isEnabled(roundNum).call();
          return details;
        }

       
          const gas = await selectedContract.methods
            .enableClaims(roundNum, decision)
            .estimateGas({ from: account });

          const details = await selectedContract.methods
            .enableClaims(roundNum, decision)
            .send({
              from: account,
              gas,
            });
          return details;
        
      } catch (error) {
        throw error;
      }
    },
    [web3, account]
  );

  return { allowClaimingHook };
};

export default AllowClaimingHook;
// import { useCallback } from "react";
// import useWeb3 from "../useWeb3";
// import environment from "../../utils/Environment";
// import {
//   getClaimsContract,
//   getLEIAClaimsContract,
//   getOlympusClaimsContract,
//   getNFAClaimsContract,
//   getAstroNovaClaimsContract,
//   getAstroNovaClaimsV2Contract,
//   getMinersClaimsContract,
//   getRainClaimsContract,
//   getRainClaimsV2Contract,
//   getRainClaimsV3Contract,
//   getMatchainClaimsContract,
//   getLuckifyClaimsContract,
//   getScrexClaimsContract
// } from "../../utils/contractHelpers";

// import { useWeb3React } from "@web3-react/core";
// import { getContracts } from "../../utils/getContracts";
// import Environment from "../../utils/Environment";

// const AllowClaimingHook = () => {
//   const web3 = useWeb3();
//   const { account } = useWeb3React();
//   const tokenAddress = environment.Claim;
//   const contract = getClaimsContract(tokenAddress, web3);

//   const tokenAddressLEIA = environment.LEIAClaim;
//   const contractLEIA = getLEIAClaimsContract(tokenAddressLEIA, web3);

//   const tokenAddressOlympus = environment.OlympusClaim;
//   const contractOlympus = getOlympusClaimsContract(tokenAddressOlympus, web3);

//   const tokenAddressNFA = environment.NFAClaim;
//   const contractNFA = getNFAClaimsContract(tokenAddressNFA, web3);

//   const tokenAddressAstroNova = environment.AstroNovaClaim;
//   const contractAstroNova = getAstroNovaClaimsContract(
//     tokenAddressAstroNova,
//     web3
//   );

//   const tokenAddressAstroNovaV2 = environment.AstroNovaClaimV2;
//   const contractAstroNovaV2 = getAstroNovaClaimsV2Contract(
//     tokenAddressAstroNovaV2,
//     web3
//   );

//   const tokenAddressRain = environment.RainClaim;
//   const contractRain = getRainClaimsContract(tokenAddressRain, web3);

//   const tokenAddressRainV2 = environment.RainClaimV2;
//   const contractRainV2 = getRainClaimsV2Contract(tokenAddressRainV2, web3);

//   const tokenAddressRainV3 = environment.RainClaimV3;
//   const contractRainV3 = getRainClaimsV3Contract(tokenAddressRainV3, web3);

//   const tokenAddressMiners = environment.MinersClaim;
//   const contractMiners = getMinersClaimsContract(tokenAddressMiners, web3);
//   const tokenAddressMatchain = environment.MATCHAINClaim;
//   const contractMatchain = getMatchainClaimsContract(tokenAddressMatchain, web3);
//   const contractLuckify = getLuckifyClaimsContract(environment?.LUCKIFYClaim, web3);
//   const contractScrex = getScrexClaimsContract(environment?.SCREXClaim, web3);
//   const project = localStorage.getItem("project");
//   // console.log(project, 'Matchain_______');
//   const allowClaimingHook = useCallback(
//     async (bool, round, decesion, project) => {
//       // project will be any of INCENTIV, MATCHAIN, LEIA etc
//       const roundNum = round?.round;
//       console.log("round in hook: ", round, project, roundNum);

//       try {
//         if (project == "INCENTIV") {
//           if (bool) {
//             const details = await contract.methods.isEnabled(roundNum).call();
//             return details;
//           } else {
//             const gas = await contract.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contract.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "LUCKIFY") {

//           // console.log(contractMatchain, 'Matchain_______');

//           if (bool) {
//             const details = await contractLuckify.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             const gas = await contractLuckify.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contractLuckify.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "SCREX") {

//           // console.log(contractMatchain, 'Matchain_______');

//           if (bool) {
//             const details = await contractScrex.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             // const gas = await contractScrex.methods
//             //   .enableClaims(roundNum, decesion)
//             //   .estimateGas({ from: account });
//             const details = await contractScrex.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 // gas,
//               });
//             return details;
//           }
//         } else if (project == "MATCHAIN") {
         
//           // console.log(contractMatchain, 'Matchain_______');

//           if (bool) {
//             const details = await contractMatchain.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             const gas = await contractMatchain.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contractMatchain.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "OLYMPUS") {
//           if (bool) {
//             const details = await contractOlympus.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             const gas = await contractOlympus.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contractOlympus.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "LEIA") {
//           if (bool) {
//             const details = await contractLEIA.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             const gas = await contractLEIA.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contractLEIA.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "NFA") {
//           if (bool) {
//             const details = await contractNFA.methods
//               .isEnabled(roundNum)
//               .call();
//             return details;
//           } else {
//             const gas = await contractNFA.methods
//               .enableClaims(roundNum, decesion)
//               .estimateGas({ from: account });
//             const details = await contractNFA.methods
//               .enableClaims(roundNum, decesion)
//               .send({
//                 from: account,
//                 gas,
//               });
//             return details;
//           }
//         } else if (project == "ASTRANOVA") {
//           if (round?.version == 1) {
//             if (bool) {
//               const details = await contractAstroNova.methods
//                 .isEnabled(roundNum)
//                 .call();
//               return details;
//             } else {
//               const gas = await contractAstroNova.methods
//                 .enableClaims(roundNum, decesion)
//                 .estimateGas({ from: account });
//               const details = await contractAstroNova.methods
//                 .enableClaims(roundNum, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } else if (round?.version == 2) {
//             if (bool) {
//               const details = await contractAstroNovaV2.methods
//                 .isEnabled(roundNum)
//                 .call();
//               return details;
//             } else {
//               const gas = await contractAstroNovaV2.methods
//                 .enableClaims(roundNum, decesion)
//                 .estimateGas({ from: account });
//               const details = await contractAstroNovaV2.methods
//                 .enableClaims(roundNum, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           }
//         } else if (project == "RAIN") {
//           if (round?.version == 1) {
//             if (bool) {
//               const details = await contractRain.methods
//                 .isEnabled(roundNum)
//                 .call();
//               return details;
//             } else {
//               const gas = await contractRain.methods
//                 .enableClaims(roundNum, decesion)
//                 .estimateGas({ from: account });
//               const details = await contractRain.methods
//                 .enableClaims(roundNum, decesion)
//                 .send({
//                   from: account,
//                   gas,
//                 });
//               return details;
//             }
//           } else if (round?.version == 2) {
//             // console.log("in this version 2 if: ");

//             if (bool) {
//               const details = await contractRainV2.methods
//                 .isEnabled(roundNum)
//                 .call();
//               return details;
//             } else {
//               // const gas = await contractRainV2.methods
//               //   .enableClaims(roundNum, decesion)
//               //   .estimateGas({ from: account });
//               const details = await contractRainV2.methods
//                 .enableClaims(roundNum, decesion)
//                 .send({
//                   from: account,
//                   // gas,
//                 });
//               return details;
//             }
//           } else if (round?.version == 3) {
//             // console.log("in this version 3 if: ");

//             if (bool) {
//               const details = await contractRainV3.methods
//                 .isEnabled(roundNum)
//                 .call();
//               return details;
//             } else {
//               // const gas = await contractRainV2.methods
//               //   .enableClaims(roundNum, decesion)
//               //   .estimateGas({ from: account });
//               const details = await contractRainV3.methods
//                 .enableClaims(roundNum, decesion)
//                 .send({
//                   from: account,
//                   // gas,
//                 });
//               return details;
//             }
//           }
//         }
//         // else if (project == "NODEMINER") {
//         //   if (bool) {
//         //     const details = await contractMiners.methods
//         //       .isEnabled(roundNum)
//         //       .call();
//         //     return details;
//         //   } else {
//         //     const gas = await contractMiners.methods
//         //       .enableClaims(roundNum, decesion)
//         //       .estimateGas({ from: account });
//         //     const details = await contractMiners.methods
//         //       .enableClaims(roundNum, decesion)
//         //       .send({
//         //         from: account,
//         //         gas,
//         //       });
//         //     return details;
//         //   }
//         // }
//       } catch (error) {
//         throw error;
//       }
//     },
//     [contract]
//   );
//   return { allowClaimingHook: allowClaimingHook };
// };
// export default AllowClaimingHook;
